import { useCallback, useState } from 'react';

type TUseModalParams = {
    initialOpen?: boolean,
};

/**
 * Позволяет избавиться от дублирования кода для модальный окон, попапов и т.д,
 * посредством того что скрывает вунтри себя состояния open / close
 */

export const useModal = (params: TUseModalParams = {}) => {
    const { initialOpen = false } = params;

    const [isOpen, setIsOpen] = useState(initialOpen);

    const openModal = useCallback(() => setIsOpen(true), []);
    const closeModal = useCallback(() => setIsOpen(false), []);
    const toggleModal = useCallback(() => setIsOpen(status => !status), []);

    return { isOpen, openModal, closeModal, toggleModal };
};
